import { Grid, Text } from '@mantine/core';
import { IconType } from 'react-icons';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { PatientDetailsFilters } from './PatientDetailsFilters';
import { PatientDetailsTitle } from './PatientDetailsTitle';

interface Props extends PropsWithChildren {
  title: string;
  Icon: IconType;
  pageDescriptionKey?: string;
  isEnabled?: boolean;
}

export const PatientDetailsGrid = ({ title, Icon, pageDescriptionKey, children, isEnabled = true }: Props) => {
  const { t } = useTranslation();
  if (!isEnabled) {
    return (
      <Text size={'sm'} m={15}>
        {t('modules_disabled_label')}
      </Text>
    );
  }
  return (
    <>
      <PatientDetailsFilters pageDescriptionKey={pageDescriptionKey} />
      <PatientDetailsTitle title={title} Icon={Icon} />
      <Grid>{children}</Grid>
    </>
  );
};
